import { render, staticRenderFns } from "./Register.license.vue?vue&type=template&id=b56ea03a&scoped=true&lang=pug&"
import script from "./Register.license.vue?vue&type=script&lang=ts&"
export * from "./Register.license.vue?vue&type=script&lang=ts&"
import style0 from "./Register.license.vue?vue&type=style&index=0&id=b56ea03a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56ea03a",
  null
  
)

export default component.exports